export const getSurveysAdapter = (listOfSurveys) => {
  return listOfSurveys.map((survey) => {
    return {
      id: survey.id,
      createAt: survey.create_at,
      updateAt: survey.update_at,
      title: survey.name,
      description: survey.description,
      url: survey.survey_link,
    };
  });
};
